
export const MapEditGeometryTypes = {
    POLYGON: 'draw_polygon',
    LINE: 'draw_line_string',
    POINT: 'draw_point'
};
 
export enum APP_SECTIONS {
    MAP_VIEWER,
    MAP_COMPARE_MODE,
    MAP_DEVICE_MODE,
    OFFLINE_DASHBOARD
  };

export interface NavigationSettings {
    activeAppSection: APP_SECTIONS | null;
    activePath: string | undefined;
    isNavigationOpen: boolean;
}

export interface NavigationStoreState {
    navigationSettings: NavigationSettings;
    setCurrentUrl: (url: string) => void;
    setIsNavigationOpen: (isOpen: boolean) => void;
};